import { Injectable } from '@angular/core';
import {
  FunctionBlockConfigEvent,
  FunctionBlockStateEvent,
} from '@ubie/mqttcommunication';
import { from, Observable, of, share, switchMap } from 'rxjs';
import { ObservableDictionary } from '../ObservableDictionary';
import { BaseCommunicationService } from './base-communication-service';
@Injectable({
  providedIn: 'root',
})
export class FunctionBlockCommunicationService extends BaseCommunicationService<
  FunctionBlockStateEvent | FunctionBlockConfigEvent
> {
  readonly createFunctionBlockItemFn = (
    key: string,
  ): Observable<FunctionBlockStateEvent | FunctionBlockConfigEvent> => {
    const [
      ubieSerialNumber,
      networkDeviceSerialNumber,
      functionblockSerialNumber,
    ] = key.split(this.KEY_SPLIT);

    return this.communicationListenerService
      .getFunctionBlockCommunicationOnly(
        ubieSerialNumber,
        networkDeviceSerialNumber,
        functionblockSerialNumber,
      )
      .pipe(share());
  };

  readonly deleteFunctionBlockItemFn = (key: string): void => {
    const [
      ubieSerialNumber,
      networkDeviceSerialNumber,
      functionblockSerialNumber,
    ] = key.split(this.KEY_SPLIT);
    this.communicationFilterService
      .disableFunctionBlocks([
        {
          device: {
            serialNumber: ubieSerialNumber,
          },
          serialNumber: functionblockSerialNumber,
          networkDevice: {
            serialNumber: networkDeviceSerialNumber,
          },
        },
      ])
      .then();
  };

  protected override readonly dictionary: ObservableDictionary<
    FunctionBlockStateEvent | FunctionBlockConfigEvent
  > = new ObservableDictionary<
    FunctionBlockStateEvent | FunctionBlockConfigEvent
  >(this.createFunctionBlockItemFn, this.deleteFunctionBlockItemFn);

  enable(key: string): Observable<void> {
    const [
      ubieSerialNumber,
      networkDeviceSerialNumber,
      functionblockSerialNumber,
    ] = key.split(this.KEY_SPLIT);
    return from(
      this.communicationFilterService.enableFunctionBlocks([
        {
          device: {
            serialNumber: ubieSerialNumber,
          },
          serialNumber: functionblockSerialNumber,
          networkDevice: {
            serialNumber: networkDeviceSerialNumber,
          },
        },
      ]),
    ).pipe(switchMap(() => of()));
  }

  override getOrAddItem(
    key: string,
  ): Observable<FunctionBlockStateEvent | FunctionBlockConfigEvent> {
    return this.dictionary.getOrAdd(key);
  }
}
